exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-border-top-none[data-v-1056655b] {\n  border-top: 0 !important;\n}\n.table-border-top-none tr td[data-v-1056655b]{\n  border-top: 0 !important;\n}\n.homecare-topic-area .home-care-table tr td[data-v-1056655b]:nth-child(odd) {\n  min-width: 165px !important;\n  max-width: 165px !important;\n}\n.homecare-topic-area .home-care-table table tr td[data-v-1056655b] {\n  min-width: 211px !important;\n  max-width: 211px !important;\n}\n.list-image[data-v-1056655b] {\n  max-height: 900px;\n}\n", ""]);

// exports
